import { createSlice } from '@reduxjs/toolkit';
import { IDialogData } from '../../../types/IComponentTypes';

const initialState: IDialogData = {
  show: false,
  message: {},
  type: '',
  manipulationType: '',
  header: {},
  detailsViewType: '',
  uniqueKey: '',
  moduleType: '',
};

const dialogSlice = createSlice({
  name: 'dialog',
  initialState,
  reducers: {
    setDialogMessage(_state, action) {
      return action.payload;
    },
    resetDialogMessage() {
      return initialState;
    },
  },
});

export const { setDialogMessage, resetDialogMessage } = dialogSlice.actions;

export const dialog = (state: IDialogData) => state;

export default dialogSlice.reducer;
